<template>
  <div>
   <el-container>
  		<el-main>
  			<el-row :gutter="20">
		  		<el-col :span="24" :offset="6" :md="12">
		  			<div class="auth-header">
		  				<img src="../../assets/logo.png">
		  			</div>
		  			<div class="signup-body auth-panel">
		  				<h1 style="margin-top:0;padding-top:70px; font-family:'prohibition'">Sorry, Registration has closed.</h1>
              <p>If you already registered you can login here <a  href="#/login">Login</a></p>
               
		  			</div>
		  		</el-col>
			</el-row>
  		</el-main>
	</el-container>
  </div>
</template>

<script>
import Steps from './steps';

export default {
  name: 'signup',
  components:{
    Steps
  },
  mounted: function(){
    if(Parse.User.current()){
      var user = Parse.User.current();
      FS.identify(user.id, {
            displayName: user.get('firstName')+" "+user.get('lastName'),
            email: user.get('email')
          });

      Intercom('boot', {  
              app_id: 'r8e7lome',  
              email: user.get('email'),
              created_at: user.get('createdAt'),
              name: user.get('firstName')+" "+user.get('lastName'),
              user_id: user.id
          });
          
      //this.$router.push('/signup/plan');
    }
  },
  methods:{
    validateForm: function(){
       this.$refs.form.validate(this.registerUser);
    },
    registerUser: function(valid){
     
      if(valid!=true){
        this.$notify({
          title: 'Erros',
          message: 'Please double check the form.',
          type: 'error'
        });
        return;
      }
      if(this.userData.password != this.userData.passwordConfirm){
        this.passwordError = "Passwords must match";
        return;
      } else {
        this.passwordError = null;
      }
      this.savingData = true;
      var _this = this;
      var user = new Parse.User();
      var email = this.userData.email.trim().toLowerCase();
      user.set("username", email);
      user.set("email", email);
      user.set("password",  this.userData.password);
      user.set("firstName", this.userData.firstName);
      user.set("lastName", this.userData.lastName);
      user.set("where", this.userData.where);
      user.signUp(null, {
        success: function(savedUser) {
          // Hooray! Let them use the app now.
          // This is an example script - don't forget to change it!
          FS.identify(savedUser.id, {
            displayName: savedUser.get('firstName')+" "+savedUser.get('lastName'),
            email: savedUser.get('email')
          });

          Intercom('boot', {  
              app_id: 'r8e7lome',  
              email: savedUser.get('email'),
              created_at: savedUser.get('createdAt'),
              name: savedUser.get('firstName')+" "+savedUser.get('lastName'),
              user_id: savedUser.id
          });

          _this.savingData = false;
          _this.$router.push('/signup/plan');
        },
        error: function(user, error) {
          _this.savingData = false;
          // Show the error message somewhere and let the user try again.
          alert("Error: " + error.code + " " + error.message);
        }
      });
    }
  },
  data () {
    return {
      passwordError: null,
      formRules: {
        firstName: [
            { required: true, message: 'First name is required', trigger: 'blur' }
        ],
        lastName:[
          { required: true, message: 'Last name is required', trigger: 'blur' }
        ],
        email:[
          { required: true, message: 'We need a valid email.', trigger: 'blur', type:'email' }
        ],
      },
      validatePass: function(rule, value, callback) {
        if (value === '') {
          callback(new Error('Please input the password'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      },
      savingData: false,
      userData:{
        firstName:null,
        lastName:null,
        email:null,
        password:null,
        passwordConfirm:null
      }
    };
  }
}
</script>

<style>

</style>
